import { Component, OnInit, ViewChild } from '@angular/core';
import { SingleoptionSinBindingComponent } from './../selects/singleoption/singleoption.component';
import { FormService } from './../../services/formServices';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from './../../../core/services/sessionService';
import { element } from 'protractor';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-guia',
  templateUrl: './guia.component.html',
  styleUrls: ['./guia.component.scss']
})
export class GuiaComponent implements OnInit {
  @ViewChild('perfil') perfil: SingleoptionSinBindingComponent; 
  form
  validation_messages
  listPerfil
  listSistema
  session
  constructor(private formService: FormService, private sessionService: SessionService, private toaster: ToastrService) { }

  ngOnInit() {
    this.session = this.sessionService.getSession();
    this.formService.getSistemasGestionUsuarios().subscribe(data => this.listSistema = data);
    this.validation_messages = {
      "sistemaAcceder": [
        { "type": "required", "message": "Debe seleccionar el sistema al que accederá" }
      ],
      "perfil": [
        { "type": "required", "message": "Debe especificar qué tipo de perfil tiene" }
      ]
    }
  
    this.form = new FormGroup({
      sistemaAcceder: new FormControl('', Validators.compose([Validators.required])),
      perfil: new FormControl('', Validators.compose([Validators.required]))
    }, { updateOn: 'blur' });
  }

  copyToClipBoard(id){
    var element = document.getElementById(id) as HTMLInputElement;
    element.select();
    try {
        var status = document.execCommand('copy');
        if(!status){
          this.toaster.warning("No se pudo copiar el texto", "Alerta");
        }else{
          this.toaster.success("Texto copiado a portapapeles!", "Éxito")
        }
    } catch (err) {
      this.toaster.error("Fallo al copiar", "Error")
    }
  }


  setSistemaAcceder(value) {
    this.formService.getPerfilesXSistema(value.id).subscribe(data => {
      this.listPerfil = data;
      this.perfil.onItemDeSelect();
    });
    this.form.patchValue({
      sistemaAcceder: value.nombre
    });
  }

  setPerfil(value) {
    if(value != ''){
      this.form.patchValue({
        perfil: value.nombre
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/guia/guia.component.ts